<template>
    <div id="prop-breadcrumbs" aria-label="Breadcrumb">
        <ul class="flex">
            <li class="list" v-for="(breadcrumb, i) in breadcrumbItems" :key="breadcrumb.url || i">
              <a class="breadcrumb" :href="breadcrumb.url">{{ breadcrumb.name }}</a>
            </li>
        </ul>
        
    </div>
</template>

<script>
export default {
  props: {
    breadcrumbItems: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';
  .flex {
    overflow-x: scroll;
    margin: 0px;
    display: block;
    flex-direction: row;
    padding: 0px;
    border: 1px solid #D9D9D9;
    scrollbar-width: none;
    margin: 0 1.25rem;

    @media #{$l-tablet} {
      display: flex;
      margin: 1.25rem 0;
      padding: 0 1.25rem;
      padding: 0;
      border: none;
    }
  }
  
  .list {
    display: flex;
    font-size: 14px;
    list-style: none;
    line-height: 16px;
    flex-direction: row;
    margin: 0px;
    border-bottom: 1px solid #D9D9D9;
    position: relative;

    &::before {
      content: "";
      background-image: url('../../assets/images/global/arrow-down.svg');
      position: absolute;
      display: block;
      width: .875rem;
      height: .875rem;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      background-size: contain;
      top: 50%;
      transform: rotate(90deg) translate(-50%);
      left: 0.75rem;
    }

    @media #{$l-tablet} {
      padding: 0;
      border: none;
      &::before {
        display: none;
      }

      &::after{
      content: ">";
      width: 16px;
      height: 14px;
      display: block;
      text-align: center;
     }

     &:last-child::after {
      display: none;
     } 
    }
  }

  .breadcrumb {
    color: $col_primary;
    max-width: unset;
    overflow: hidden;
    white-space: nowrap;
    text-decoration: none;
    text-overflow: ellipsis;
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    padding: 1.125rem 1.25rem 1.125rem 2rem;
    @media #{$l-tablet} { 
      padding: 0;
    }
  }
  
</style>



